import { io } from "socket.io-client";

let socket = null;
// Derive the socket origin from the same API URL used by axiosInstance, so the
// socket always points at whichever backend REACT_APP_API_URL is configured for.
const SERVER_URL = (
  process.env.REACT_APP_API_URL || "https://backend.webbirth.online:5030/api"
).replace(/\/api\/?$/, "");

export const initializeSocket = (token) => {
  if (!token) return null;
  if (socket) return socket;

  socket = io(SERVER_URL, {
    auth: { token },
    transports: ["websocket"],
    reconnection: true,
  });

  socket.on("connect", () => {
  });

  socket.on("connect_error", (err) => {
    console.error("🔴 Socket error:", err.message);
  });

  return socket;
};

export const getSocket = () => socket;
